$(document).ready(() => {
  const updateTitleHeight = () => {
      let titleHeight = $(".our-values-section .our-values-row .title-wrap .title").outerHeight(true);
      $(".our-values-section .our-values-row .col-right").css("--title-height", `${titleHeight}px`);
  };

  // Initial call
  updateTitleHeight();

  // Update on window resize
  $(window).on("resize", updateTitleHeight);
});
